export default "__VITE_ASSET__trlLBODP__"